import { inject, Injectable } from '@angular/core'
import { FeathersService } from '../../../../services/feathers.service'
import { AssistantAssignment } from '../../../../models/assistantAssignment'

@Injectable({
  providedIn: 'root',
})
export class AssistanceEditorWorkerSelectService {
  protected feathers = inject(FeathersService)

  async patchAssignment(assignmentId: number, record: any) {
    console.log('patchAssignment', ...arguments)
    await this.feathers.patch(AssistantAssignment.serviceName, {
      id: assignmentId,
      ...record,
    })
  }
}
